export const SERVER_ERR_MSG = "Something went wrong! Please try again";
